import { ActionBadge } from "components/ActionBadge/index";
import { Avatar } from "components/Avatar";
import { getStockCompanyIcon } from "utils";

export const tradeColumns = [
  {
    dataField: "asset",
    text: "Asset",
    props: {
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="asset-item-left">
            <Avatar
              size={30}
              round={true}
              name={data?.asset}
              className="asset-img"
              src={getStockCompanyIcon(data.asset)}
            />
            <div className="asset-wrapper">
              <div className="asset-title text-ellipsis"> {data?.asset}</div>
              <div className="asset-description">{data?.company_name}</div>
            </div>
          </div>
        );
      },
    },
  },
  {
    dataField: "side",
    text: "Side",
    props: {
      cell: ({ getValue }) => {
        const value = getValue().toUpperCase();
        if (!value) {
          return <span>-</span>;
        }
        return <ActionBadge type={value} />;
      },
    },
  },
  {
    dataField: "qty",
    text: "Quantity",
  },
  {
    dataField: "date",
    text: "Date",
  },
];
